class Falecom {

	buttons = false
	header = false
	target = false
	closeButton = false
	handleOut = null

	constructor() {

		this.buttons = document.querySelectorAll('button.fale-conosco,a[href="#contato"]')
		this.target = document.querySelector('.floater-destaques')
		this.header = document.querySelector('#masthead')

		if (this.target && this.buttons.length) {

			this.handleOut = this.clickOut.bind(this)

			for (const button of this.buttons) {

				button.addEventListener('click', (event) => {

					event.preventDefault()
					if (this.target.classList.contains('opened')) {
						this.close()
					}
					else {
						this.open()
					}

				})

			}

			// Close button
			this.closeButton = this.target.querySelector('button.close')
			this.closeButton.addEventListener('click', (event) => {
				event.preventDefault()
				this.close()
			})

			// Bind finished
			const form = document.querySelector('#contact')
			form.addEventListener('finished', () => {
				this.close()
			})

		}

	}

	clickOut(event) {
		if (
			!Piki.hasParent(event.target, 'floater-destaques')
			&&
			!event.target.classList.contains('floater-destaques')
			&&
			!Piki.hasParent(event.target, 'fale-conosco')
			&&
			!event.target.classList.contains('fale-conosco')
			&&
			!$(event.target).parents('[href="#contato"]').length
			&&
			!event.target.href === '#contato'
		) {
			this.close()
		}
	}

	open() {

		this.target.classList.add('opened')
		window.addEventListener('click', this.handleOut)

		// const button = document.querySelector('button.fale-conosco')
		// button.addEventListener('click', (event) => {
		// 	event.preventDefault()
		// 	this.close()
		// })

		if (this.header.classList.contains('sticky')) {
			this.header.classList.remove('to-down')
			this.header.classList.add('to-up')
		}

		//if( window.innerHeight === this.target.offsetHeight ){
		Piki.lockScroll()
		//}

	}

	close() {

		this.target.classList.remove('opened')
		window.removeEventListener('click', this.handleOut)
		Piki.unlockScroll()

		// const button = document.querySelector('button.fale-conosco')
		// button.addEventListener('click', (event) => {
		// 	event.preventDefault()
		// 	this.open()
		// })

	}

}

window.addEventListener('DOMContentLoaded', () => {
	new Falecom()
});